const REDACTED = "[redacted]";
// Query hashes are serialized keys, not cryptographic hashes. Drop identities wholesale,
// including opaque credentials that cannot be recognized by inspecting their value.
const SENSITIVE_KEY = /^(?:querykey|queryhash|mutationkey|contextkey|accesstoken|refreshtoken|token|authorization|cookie|password|secret|apikey)$/i;

export function redactTelemetryText(value: string): string {
  return value
    .replace(/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, REDACTED)
    .replace(/\bBearer\s+[^\s"'<>;,]+/gi, `Bearer ${REDACTED}`)
    .replace(/((?:access[_-]?token|refresh[_-]?token|token|api[_-]?key|authorization|password|secret)\s*["']?\s*[:=]\s*["']?)[^\s"'&;,}]+/gi, `$1${REDACTED}`);
}

/** Bounded, non-mutating JSON traversal shared by RPC and fallback telemetry writes. */
export function redactTelemetryValue<T>(value: T): T {
  const seen = new WeakSet<object>();
  const visit = (item: unknown, depth: number): unknown => {
    if (typeof item === "string") return redactTelemetryText(item);
    if (item === null || typeof item !== "object") return item;
    if (depth > 12 || seen.has(item)) return REDACTED;
    seen.add(item);
    try {
      if (Array.isArray(item)) return item.map(child => visit(child, depth + 1));
      return Object.fromEntries(Object.entries(item).map(([key, child]) => [
        redactTelemetryText(key),
        SENSITIVE_KEY.test(key.replace(/[_-]/g, "")) ? REDACTED : visit(child, depth + 1),
      ]));
    } catch {
      return REDACTED;
    }
  };
  return visit(value, 0) as T;
}
